import React, {useEffect, useState} from "react";
import {Spin} from "antd";
import "./style.css";
import clickService from "../../../services/clickService";
import {getFingerprintData} from '../../../utils/fingerprintAuth';
import Turnstile from "react-turnstile";

interface LoadingPageProps {
    hash: string;
    target: string;
}

const LoadingPage: React.FC<LoadingPageProps> = ({hash, target}) => {
    const [captchaToken, setCaptchaToken] = useState<string | null>(null);
    const [clickId] = useState<string>(window.crypto.randomUUID());
    const [wasInteractive, setWasInteractive] = useState<boolean>(false);
    const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || '';

    useEffect(() => {
        const handleClickValidation = async () => {
            if (captchaToken === null) return;
            const captcha = wasInteractive ? {token: captchaToken, suspicious: false} : {};

            const payload = {hash, metadata: await getFingerprintData('clickValidation', captcha)};

            try {
                await clickService.validateClick(clickId, payload);
            } catch (error) {
                console.error("Click validation failed:", error);
            } finally {
                window.location.href = target;
            }
        };

        handleClickValidation();
    }, [captchaToken, wasInteractive, hash, target]);

    useEffect(() => {
        const t0 = performance.now();
        return () => console.log('unmount after', performance.now() - t0, 'ms');
    }, []);

    const tMount = performance.now();

    return (
        <div className="loading-container">
            <div className="loading-content">
                <p className="loading-text">Redirecting you to the page...</p>
                <Spin size="large" className="loading-spinner"/>

                {SITE_KEY && (
                    <Turnstile
                        appearance={"interaction-only"}
                        sitekey={SITE_KEY}
                        cData={clickId}
                        theme={"light"}
                        onVerify={(token) => {
                            console.log('turnstile verified in', performance.now() - tMount, 'ms');
                            setCaptchaToken(token)
                        }}
                        onAfterInteractive={() => {
                            console.log('turnstile interactive in', performance.now() - tMount, 'ms');
                            setWasInteractive(true)
                        }}
                    />
                )}

                <p className="loading-powered">
                    <img src="/assets/images/promotify-transparent.png" alt="Promotify Logo" className="loading-logo"/>
                </p>
            </div>
        </div>
    );
};

export default LoadingPage;